import axios from '../Backend';

export const getBaseRecordsByModuleId = async (moduleId, page, limit, sortBy, order, filters) => {
    try {
        if (!moduleId) return console.log('Module not selected.')
        const reqBody = {
            moduleId,
            page,
            limit,
            sortBy,
            order,
            filters
        }

        const res = await axios.post('/api/v2/effective-crms/module-record/search', reqBody);
        // Return full response for pagination info, not just records
        return res.data
    } catch (e) {
        console.log(`getModules :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const getBaseRecordsByModuleModuleType = async (moduleType, page, limit, sortBy, order, filters) => {
    try {
        if (!moduleType) return console.log('Module not selected.')
        const reqBody = {
            moduleType,
            page,
            limit,
            sortBy,
            order,
            filters
        }

        const res = await axios.post('/api/v2/effective-crms/module-record/search', reqBody);
        return res.data?.data?.records
    } catch (e) {
        console.log(`getModules :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const getBaseRecordById = async (recordId) => {
    try {
        if (!recordId) return console.log('Record not selected.')

        const res = await axios.get(`/api/v2/effective-crms/module-record/${recordId}`);
        return res.data?.data?.record
    } catch (e) {
        console.log(`getBaseRecordById :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const insertBaseRecord = async (moduleId, bodyFields = {}) => {
    try {
        if (!moduleId) return console.log('Module not selected.')

        const reqBody = {
            moduleId,
            ...bodyFields
        }
        const res = await axios.post('/api/v2/effective-crms/module-record/', reqBody);
        return res.data?.data?.record
    } catch (e) {
        console.log(`insertBaseRecord :: Error=${e.response?.data ? e.response.data.message : e.message}`)
        throw e
    }
}

export const patchBaseRecord = async (moduleId, recordId, bodyFields = {}) => {
    try {
        if (!moduleId) return console.log('Module not selected.')
        if (!recordId) return console.log('Record not selected.')

        const reqBody = {
            moduleId,
            ...bodyFields
        }

        const res = await axios.patch(`/api/v2/effective-crms/module-record/${recordId}`, reqBody);

        return res.data?.data?.record
    } catch (e) {
        console.log(`patchBaseRecord :: Error=${e.response?.data ? e.response.data.message : e.message}`)
        throw e
    }
}


export const linkRelatedRecords = async (recordId, targetId, sourceModuleId, targetModuleId) => {
    try {
        if (!sourceModuleId) return console.log('sourceModuleId not selected.')
        if (!targetModuleId) return console.log('targetModuleId not selected.')
        if (!targetId) return console.log('targetId not selected.')
        if (!recordId) return console.log('recordId not selected.')

        const reqBody = {
            targetId, sourceModuleId, targetModuleId
        }

        const res = await axios.post(`/api/v2/effective-crms/module-record/${recordId}/link`, reqBody);
        return res.data?.status
    } catch (e) {
        console.log(`linkRelatedRecords :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const unLinkRelatedRecords = async (recordId, targetId, sourceModuleId, targetModuleId) => {
    try {
        if (!sourceModuleId) return console.log('sourceModuleId not selected.')
        if (!targetModuleId) return console.log('targetModuleId not selected.')
        if (!targetId) return console.log('targetId not selected.')
        if (!recordId) return console.log('recordId not selected.')

        const reqBody = {
            targetId, sourceModuleId, targetModuleId
        }

        const res = await axios.post(`/api/v2/effective-crms/module-record/${recordId}/unlink`, reqBody);
        return res.data?.status
    } catch (e) {
        console.log(`unLinkRelatedRecords :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const deleteBaseRecord = async (recordId) => {
    try {
        if (!recordId) return console.log('recordId not selected.')

        const res = await axios.delete(`/api/v2/effective-crms/module-record/${recordId}`);
        return res.data?.status
    } catch (e) {
        console.log(`deleteBaseRecord :: Error=${e.response?.data ? e.response.data.message : e.message}`)
        throw e
    }
}

export const searchBaseRecordByPhone = async (phone) => {
    try {
        if (!phone) return undefined;
        const res = await axios.get(`/api/v2/effective-crms/module-record/search-by-phone?phone=${encodeURIComponent(phone)}`);
        return res.data?.data?.record || undefined;
    } catch (e) {
        console.error('searchBaseRecordByPhone :: Error', e?.response?.data?.message || e.message);
        return undefined;
    }
}

export const deleteBaseRecords = async (recordIds) => {
    try {
        if (!recordIds || !Array.isArray(recordIds) || recordIds.length === 0) {
            return console.log('recordIds array not provided or empty.')
        }

        const reqBody = {
            recordIds
        }

        const res = await axios.post('/api/v2/effective-crms/module-record/batch-delete', reqBody);
        return res.data
    } catch (e) {
        console.log(`deleteBaseRecords :: Error=${e.response?.data ? e.response.data.message : e.message}`)
        throw e
    }
}